{
  "id": "bancos",
  "nome": "Bacen STR Participants",
  "fonte": "Banco Central — Participantes STR",
  "endpoints": [
    "https://www.bcb.gov.br/content/estabilidadefinanceira/str1/ParticipantesSTR.csv"
  ],
  "capturadoEm": "2026-08-05",
  "atualizadoEm": "2026-08-05T05:40:10.952Z",
  "contagens": {
    "bancos": 470
  },
  "alteracoes": {
    "adicionados": 0,
    "removidos": 0,
    "alterados": 1,
    "comparadoCom": "2026-08-04"
  },
  "verificacao": {
    "agendamento": "diario",
    "workflow": "data-refresh-bot.yml",
    "ultimaExecucao": "2026-08-05T05:40:10.952Z"
  },
  "documentacao": "docs/OFFICIAL-SOURCES.md#bacen-banks"
}
